<template>
  <div class="contractor__container-user" v-if="profile.permissions.CAN_VIEW_ORG_USERS">
    <hr>
    <div class="a-container-form contractor__block">
      <div class="a-label">{{$t('form.contractor.contractor-fullname')}}:</div>
      <router-link class="gui-btn gui-btn--link"
                   :to="{name: 'catalogs-users-account', params: { userId: user.id, tab: 'account'}}">
        {{user | fullName}}
      </router-link>
      <span class="contractor__user-main" v-if="user.isMain">
            <img src="@/assets/img/static/star.svg" alt="">
            {{$t('form.contractor.appointed-main')}}
      </span>
    </div>
    <div class="human-data__block" v-if="user.roles.length > 0">
      <div class="a-label " v-t="'labels.roles'">:</div>
      <p class="a-input a-input--disabled">
        <span v-for="(role, idx) in user.roles">{{idx ? ', ' : ''}}{{$t(role.label)}}</span>
      </p>
    </div>
    <div class="a-container-form contractor__block" v-if="mainUser">
      <div class="a-label">{{$t('form.contractor.subordination')}}:</div>
      <p class="a-input a-input--disabled">{{mainUser | fullName}}</p>
    </div>
    <div class="a-container-form contractor__block">
      <div class="a-label">{{$t('labels.email')}}:</div>
      <p class="a-input a-input--disabled">{{user.email.verified || user.email.unverified}}</p>
    </div>
    <div class="a-container-form contractor__block">
      <div class="a-label">{{$t('labels.phone-short')}}:</div>
      <p class="a-input a-input--disabled">{{user.phone.verified || user.phone.unverified}}</p>
    </div>
    <div class="gui-btn-block contractor__btn-block">
      <button class="gui-btn gui-btn--red gui-btn--w-230"
              :disabled="!user.isMain"
              v-if="permissions.CAN_ASSIGN_MAIN"
              @click.prevent="OnAssignMainClick">
        {{$t('form.contractor.appoint-main')}}
      </button>
      <button class="gui-btn gui-btn--red gui-btn--w-278"
              v-if="!user.needManualReview && permissions.CAN_ASSIGN_MANUAL_REVIEW"
              @click.prevent="OnToggleManualReviewClick">
        {{$t('form.contractor.assign-manual-checks')}}
      </button>
      <button class="gui-btn gui-btn--red gui-btn--w-278"
              v-if="user.needManualReview"
              :disabled="!permissions.CAN_ABORT_MANUAL_REVIEW"
              @click.prevent="OnToggleManualReviewClick">
        {{$t('form.contractor.cancel-manual-checks')}}
      </button>
      <button class="gui-btn gui-btn--red gui-btn--w-278"
              v-if="!user.inCommission && permissions.CAN_ADD_TO_COMMISSION"
              @click.prevent="OnToggleCommissionMemberClick">
        {{$t('form.contractor.add-to-commission')}}
      </button>
      <button class="gui-btn gui-btn--red gui-btn--w-278"
              v-if="user.inCommission"
              :disabled="!permissions.CAN_REMOVE_FROM_COMMISSION"
              @click.prevent="OnToggleCommissionMemberClick">
        {{$t('form.contractor.remove-from-commission')}}
      </button>
      <button class="gui-btn gui-btn--red gui-btn--w-278"
              v-if="permissions.CAN_BE_MAIN_ORGANIZER"
              @click.prevent="onSetMainOrganizerClick">
        Назначить главным организатором
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    props: [ 'user', 'profile', 'organization' ],

    computed: {
      permissions() {
        return this.user.permissions;
      },

      mainUser() {
        const userId = this.user.mainUser;
        return userId ? this.$store.getters.user(userId) : undefined;
      }
    },

    methods: {
      OnAssignMainClick() {
        this.runAction(async () => {
          try {
            await this.$store.dispatch('changeMainUserFlag', { userId: this.user.id, organizationId: this.organization.id });
          }
          catch(e) {
            console.error('unable to appoint user as main', e);
            this.globalErrorHandler(e);
          }
        });
      },

      OnToggleManualReviewClick() {
        this.runAction(async () => {
          try {
            await this.$store.dispatch('changeMainReviewFlag', { userId: this.user.id, organizationId: this.organization.id, flag: !this.user.needManualReview });
          }
          catch(e) {
            console.error('unable to toggle manual checks', e);
            this.globalErrorHandler(e);
          }
        });
      },

      OnToggleCommissionMemberClick() {
        this.runAction(async () => {
          try {
            await this.$store.dispatch('changeCommissionMemberFlag', { userId: this.user.id, organizationId: this.organization.id, flag: !this.user.inCommission });
          }
          catch(e) {
            console.error('unable to add/remove user to/from commission', e);
            this.globalErrorHandler(e);
          }
        });
      },

      onSetMainOrganizerClick() {
        this.runAction(async () => {
          try {
            await this.$store.dispatch('markOrgAsMainOrganizer', {
              userId: this.user.id
            });
          }
          catch(e) {
            console.error('unable to mark org as main organizer', e);
            this.globalErrorHandler(e);
          }
        });
      }
    }
  }
</script>

<style scoped>
  .gui-btn[disabled] {
    background: #E6E6E6;
    color: #808080;
  }
</style>
